import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { size, map, filter } from "lodash"; // Importa el método filter
import { ClientDBItems } from "../ClientDBItems";
import { ClientDB_API } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./ClientDBList.scss";

const clientController = new ClientDB_API();

export function ClientDBList(props) {
  const { user } = useAuth();
  const { reload, onReload } = props;
  const [clients, setClients] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(1);
  const idClient_ = user.user.idClient;
  //console.log("user.idClient:", user.user.idClient); // Imprimimos el idClient del usuario

  useEffect(() => {
    (async () => {
      try {
        const response = await clientController.getClients({ page, limit: 3 }); //le envio un objeto con page y limit

        //console.log("Clientes recibidos:", response.clients.docs); // Imprimimos todos los clientes recibidos
        //console.log("user.idClient:", idClient_); // Imprimimos el idClient del usuario

        // Filtramos los clientes que coincidan con el idClient
        const filteredClients = filter(response.clients.docs, (client) => {
          //console.log("Comparando:", client._id, "con", idClient_); // Añadimos un log para verificar la comparación
          return client._id === idClient_;
        });

        //console.log("Clientes filtrados:", filteredClients); // Imprimimos los clientes filtrados

        setClients(filteredClients); // Solo mostramos los clientes filtrados

        setPagination({
          limit: response.clients.limit,
          page: response.clients.page,
          total: response.clients.totalPages,
          totalDocs: response.clients.totalDocs,
        });
      } catch (error) {
        throw error;
      }
    })();
  }, [page, reload, idClient_]); //se vuelve a ejecutar cada vez que cambie la página

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!clients) return <Loader active inline="centered" />; // Muestra el loader mientras se carga la data
  if (size(clients) === 0) return <h2>No hay clientes</h2>; // Si no hay clientes, muestra este mensaje

  return (
    <div className="list-clients">
      {map(clients, (client) => (
        <ClientDBItems key={client._id} client={client} onReload={onReload} />
      ))}

      <div className="list-clients__pagination">
        <Pagination
          totalPages={pagination.total}
          defaultActivePage={pagination.page}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
